import { Fragment } from "react";

export default function Marquee({ items }) {
  return (
    <div className="marquee overflow-hidden border-y border-ink/10 bg-sand2 py-6" data-testid="editorial-marquee">
      <div className="marquee-track items-center">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex shrink-0 items-center">
            {items.map((item, i) => (
              <Fragment key={`${dup}-${i}`}>
                <span className={`whitespace-nowrap px-8 font-serif text-2xl lg:text-3xl ${i % 2 ? "italic text-ink" : "text-ink"}`}>
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-champagne" aria-hidden="true" />
              </Fragment>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
